// extracted by mini-css-extract-plugin
export default {"title":"bulk-emailing-NameCell__title--ZJF4D","details":"bulk-emailing-NameCell__details--OzBnl"};